import { getters } from '/@/modules/core/app/helpers/store';
import { PaidPlanRouteConfig } from '/@/modules/core/app/helpers/PaidPlanRouteConfig';

export class AccountingConnectionsRouteConfig extends PaidPlanRouteConfig {
  /**
   * @returns {boolean}
   */
  canAccessRoute() {
    const authUser = getters.auth.getUser();
    const currentEstate = getters.auth.getCurrentEstate();

    if (authUser.currentEstate?.isUnPaidSelfServePlan) {
      return true;
    }

    return (
      (currentEstate.jurisdiction.isInUnitedStates &&
        (authUser.permission.canAccessPlaid || authUser.permission.canAccessPlaidSandbox)) ||
      (currentEstate.jurisdiction.isInCanada &&
        (authUser.permission.canAccessFlinks || authUser.permission.canAccessFlinksSandbox))
    );
  }
}
